(function () {
    'use strict';

    angular
        .module('app')
        .directive('drvTaskList', drvTaskList);

    drvTaskList.$inject = [];
    drvTaskListCtrl.$inject = [
        '$location',
        '$q',
        '$scope',
        '$filter',
        'ChilliUserProfileService',
        'DialogService',
        'EntitiesService',
        'NavigationAidService',
        'SystemService',
        'TasksService',
        'Task',
        'TagsService'];

    /**
     * Directive for loading, displaying and modifying tasks in a list display
     *
     * # Scope Properties
     * {string} mode - The mode used for the task list. This will affect how the directive is displayed and operates.
     *                 MODES
     *                 'Entity': Used to show a task list in the entity edit view. For this mode, the entityId parameter must also be supplied.
     *                 'User' : Defaults to showing the tasks assigned to the current user.
     * {int} entityId - Used for filtering tasks shown by requiring them to have a Link matching the entityId. This is only used for 'Entity' mode.
     * {function} listUpdated - Optional. Callback, triggered when list is updated.
     */
    function drvTaskList() {
        var directive = {
            restrict: 'E',
            scope: {},
            controller: drvTaskListCtrl,
            controllerAs: 'drvCtrl',
            bindToController: {
                mode: '<',
                entityId: '<?',
                listUpdated: '&?'
            },
            templateUrl: 'app/Task/task-list.tmpl.html'
        };
        return directive;
    }

    function drvTaskListCtrl(
        $location,
        $q,
        $scope,
        $filter,
        ChilliUserProfileService,
        DialogService,
        EntitiesService,
        NavigationAidService,
        SystemService,
        TasksService,
        Task,
        TagsService) {

        /* jshint validthis:true */
        var drvCtrl = this;
        drvCtrl.allTasksSelected = false;

        drvCtrl.searchText = '';
        drvCtrl.searchTagIds = [];
        drvCtrl.searchDelay = SystemService.getSearchDelay();
        drvCtrl.showCompleted = false;

        drvCtrl.listPageSize = 10;
        drvCtrl.currentPage = 1;
        drvCtrl.showDeleted = false;
        drvCtrl.newTask = newTask;
        drvCtrl.deleteTask = deleteTask;
        drvCtrl.deleteTasks = deleteTasks;
        drvCtrl.copyTasks = copyTasks;
        drvCtrl.completeTasks = completeTasks;
        drvCtrl.close = close;
        drvCtrl.updateList = updateList;
        drvCtrl.loadCount = loadCount;
        Object.defineProperty(drvCtrl, 'subViewMode', { get: function () { return drvCtrl.mode === 'Entity'; } });
        Object.defineProperty(drvCtrl, 'selectedTasks', {
            get: function () {
                return _(drvCtrl.tasks)
                    .filter('Selected')
                    .value();
            }
        });
        Object.defineProperty(drvCtrl, 'titleText', { get: getTitleText });
        drvCtrl.formatFieldDisplay = formatFieldDisplay;
        drvCtrl.getDueDateColour = Task.getDueDateColour;

        activate();

        function activate() {
            var loadPromises = [];
            loadPromises.push(loadListPageSize());
            loadPromises.push(loadUserEntities());

            getTags();

            $q.all(loadPromises)
                .then(function () {
                    if (drvCtrl.mode === 'User') {
                        ChilliUserProfileService.getUserProfile()
                            .then(function (data) {
                                drvCtrl.assignedToId = data.Id;
                                updateList();
                                loadCount();
                            }, function (response) {
                                DialogService.error('Error fetching User profile', response);
                            });
                    } else {
                        updateList();
                        loadCount();
                    }

                    function setupSearchListener(scopeVarName) {
                        $scope.$watch(scopeVarName, function (newVal, oldVal) {
                            if (newVal !== oldVal) {
                                updateList();
                            }
                        });
                    }

                    setupSearchListener('drvCtrl.currentPage');
                    setupSearchListener('drvCtrl.searchText');
                    setupSearchListener('drvCtrl.assignedToId');
                    setupSearchListener('drvCtrl.searchTagIds');
                    $scope.$watch('drvCtrl.showDeleted', function (newVal, oldVal) {
                        if (newVal !== oldVal) {
                            updateList();
                            loadCount();
                        }
                    });
                    $scope.$watch('drvCtrl.showCompleted', function (newVal, oldVal) {
                        if (newVal !== oldVal) {
                            updateList();
                            loadCount();
                        }
                    });
                });
        }

        /**
         * Load the Tasks list page size
         */
        function loadListPageSize() {
            return SystemService.getMenuListSize('Tasks')
                .then(getListPageSizeOk, getListPageSizeError);

            function getListPageSizeOk(data) {
                drvCtrl.listPageSize = data;
            }

            function getListPageSizeError(response) {
                DialogService.error('Error fetching list size', response);
            }
        }

        function loadUserEntities() {
            return EntitiesService.query({
                skipSecurity: true,
                previewTextOnly: true,
                EntityType: 'User'
            })
                .then(getUserEntitiesOk, getUserEntitiesError);

            function getUserEntitiesOk(data) {
                drvCtrl.users = data.Entities;
            }

            function getUserEntitiesError(response) {
                DialogService.error('Error fetching Users', response);
            }
        }

        /*
         * Complete/uncomplete the selected tasks
         *
         * @param {bool} complete - If true the tasks were be completed, otherwise they will be uncompleted
         */
        function completeTasks(complete) {
            if (ensureTasksSelection()) {
                DialogService.show({
                    locals: {
                        complete: complete,
                        prefilledNote: ''
                    },
                    controller: 'CompleteTaskDialogCtrl',
                    controllerAs: 'vm',
                    templateUrl: 'app/task/complete-task-dialog.tmpl.html'
                })
                    .then(completeTaskDialogOk);
            }

            function completeTaskDialogOk(completeTaskNote) {
                drvCtrl.loading = true;
                TasksService.completeTasks(complete, _.map(drvCtrl.selectedTasks, 'Id'), completeTaskNote)
                    .then(completeTasksOk)
                    .catch(completeTasksError);

                function completeTasksOk(response) {
                    updateList();
                    loadCount();
                }

                function completeTasksError(response) {
                    drvCtrl.loading = false;
                    DialogService.error('Error ' + (complete ? 'completing' : 'uncompleting') + ' Task(s)', response);
                }
            }
        }

        /**
         * Update the list of tasks being displayed
         */
        function updateList() {
            if (updateList.currentPromise === undefined) {
                updateList.currentPromise = null;
            }
            drvCtrl.loading = true;

            var request = {
                currentPage: drvCtrl.currentPage,
                pageSize: drvCtrl.listPageSize,
                completed: drvCtrl.showCompleted,
                genericSearch: drvCtrl.searchText,
                tagIds: drvCtrl.searchTagIds
            };

            if (!_.isNil(drvCtrl.entityId)) {
                request.LinkedEntityId = drvCtrl.entityId;
            }

            if (!_.isNil(drvCtrl.assignedToId) && drvCtrl.assignedToId !== '') {
                request.AssignedToId = drvCtrl.assignedToId;
            }

            var getPromise = TasksService.query(request)
                .then(getTasksOk, getTasksError)
                .then(function () {
                    drvCtrl.loading = false;
                });

            updateList.currentPromise = getPromise;

            return getPromise;

            function getTasksOk(data) {
                if (getPromise === updateList.currentPromise) {
                    drvCtrl.error = null;
                    drvCtrl.allTasksSelected = false;
                    drvCtrl.tasks = data.Tasks;
                    drvCtrl.taskCount = data.TaskCount;
                    mergeTagData();

                    if (angular.isFunction(drvCtrl.listUpdated)) {
                        drvCtrl.listUpdated();
                    }
                } else {
                    return $q.reject();
                }
            }

            function getTasksError(response) {
                if (getPromise === updateList.currentPromise) {
                    drvCtrl.error = response;
                }
                else {
                    return $q.reject();
                }
            }
        }

        function loadCount() {
            var completed = null;
            if (!drvCtrl.showDeleted) {
                completed = drvCtrl.showCompleted;
            }
            var deleted = drvCtrl.showDeleted;

            return TasksService.count(completed, deleted)
                .then(loadCountOk, loadCountError);

            function loadCountOk(count) {
                drvCtrl.totalCount = count;
            }

            function loadCountError(response) {
            }
        }

        /**
         * Delete task with the supplied id and then refresh the task list
         */
        function deleteTask(taskId) {
            DialogService.confirm('Delete the selected Task?', 'Task delete confirm').then(deleteOk);

            function deleteOk() {
                TasksService.remove(taskId)
                    .then(deleteTaskOk, deleteTaskError);

                function deleteTaskOk(success) {
                    updateList();
                    loadCount();
                }

                function deleteTaskError(response) {
                    DialogService.error('Error deleting Task', response);
                }
            }
        }

        /**
         * Delete the tasks selected in the list.
         */
        function deleteTasks() {
            var selectedTaskIds = _.map(drvCtrl.selectedTasks, 'Id');
            var taskLabel = 'Task';
                if (selectedTaskIds.length > 1) {
                    taskLabel += 's';
                }

            if (ensureTasksSelection()) {
                DialogService
                    .confirm('Delete the ' + selectedTaskIds.length + ' selected ' + taskLabel + '?', 'Delete ' + taskLabel + ' confirm')
                    .then(deleteTasksConfirmed);
                    }

            function deleteTasksConfirmed() {
                TasksService.multiDelete(selectedTaskIds)
                    .then(deleteTasksOk, deleteTasksError);
            }

            function deleteTasksOk(success) {
                updateList();
                loadCount();
            }

            function deleteTasksError(response) {
                DialogService.error('Error deleting ' + taskLabel, response);
            }
        }

        /**
         * Copy the tasks selected in the list.
         */
        function copyTasks() {
             var selectedTaskIds = _.map(drvCtrl.selectedTasks, 'Id');
             var taskLabel = 'Task';
             if (selectedTaskIds.length > 1) {
                 taskLabel += 's';
             }

             if (ensureTasksSelection()) {
                DialogService
                    .confirm('Copy the ' + selectedTaskIds.length + ' selected ' + taskLabel + '?', 'Copy ' + taskLabel + ' confirm')
                    .then(copyTasksConfirmed);
            }

             function copyTasksConfirmed() {
                 TasksService.multiCopy(selectedTaskIds)
                    .then(copyOk, copyError);
            }

            function copyOk() {
                updateList();
                loadCount();
            }

            function copyError(response) {
                DialogService.error('Error copying ' + taskLabel, response);
            }
        }

        /**
         * Redirects to the new task route
         */
        function newTask() {
            switch (drvCtrl.mode) {
                case 'Entity':
                    $location.url('/tasks/new?entityId=' + drvCtrl.entityId);
                    break;
                default:
                    $location.url('/tasks/new');
                    break;
            }
        }

        /**
         * Ensure at least one task is selected.
         * Displays a dialog 'No tasks were selected' if no tasks are selected.
         * @return {bool} true if at least one task is selected, else false
         */
        function ensureTasksSelection() {
            if (drvCtrl.selectedTasks.length === 0) {
                DialogService.alert('No Tasks were selected');
                return false;
            } else {
                return true;
            }
        }

        /**
         * When the view is 'closed' navigation to a previous page should occur.
         */
        function close() {
            NavigationAidService.goBack();
        }

        /*
         * Formats the supplied field so it's user readable
         *
         * @param {object} task - Task which contains the field
         * @param {string} field - Name of the field which is to be formatted
         *
         * @returns {string} - Returns the field in user readable format
         */
        function formatFieldDisplay(task, field) {
            var result = '';

            if (!angular.isUndefined(task[field])) {
                switch (field) {
                    case 'Due':
                    case 'CompletedDate':
                        result = $filter('date')(task[field], 'medium');
                        break;
                    default:
                        result = angular.copy(task[field]);
                        break;
                }
            }

            return result;
        }

        /**
         * Get all tags
         */
        function getTags() {
            TagsService.query({ tagUsage: 'Task' })
                .then(getTagsOk, getTagsError);

            function getTagsOk(data) {
                drvCtrl.tags = data.Tags;
                mergeTagData();
            }

            function getTagsError(response) {
                DialogService.error('Error loading task Tags', response);
            }
        }

        /**
         * Merge tag data with task data for presentation.
         */
        function mergeTagData() {

            // task.Tags is a list of tag ids (numbers)
            // tags is a list of Tag objects, where Id is the tag id

            if (!_.isNil(drvCtrl.tasks) && !_.isNil(drvCtrl.tags) && drvCtrl.tags.length > 0) {
                _.forEach(drvCtrl.tasks, function (task) {
                    task.PopulatedTags = _.filter(drvCtrl.tags, function (t) {
                        return _.includes(task.Tags, t.Id);
                    });
                });
            }
        }

        /**
         * Gets the view title
         *
         * @returns {string}
         */
        function getTitleText() {
            var result = '';

            if (drvCtrl.showDeleted === true) {
                result += 'Deleted ';
            } else if (drvCtrl.showCompleted === true) {
                result += 'Completed ';
            }

            result += 'Tasks';

            return result;
        }
    }
})();